var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"btn btn-icon btn-light btn-hover-primary mr-3",attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('refreshClicked', $event)}}},[_c('span',{staticClass:"svg-icon svg-icon-2x svg-icon-primary"},[_c('inline-svg',{attrs:{"src":"/media/svg/icons/Media/Repeat.svg"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }